import React from 'react';
import ReactDOM from 'react-dom';
import './bootstrap/css/bootstrap.min.css';
import './intranet.css';
import './index.css';
import './responsive.css';
import './font-awesome.css';
import './all.css';
import "./ag-theme-intranet.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import Routing from './Routing';
//import App from './App';
import config from 'react-global-configuration';
import * as serviceWorker from './registerServiceWorker';
import { Provider } from "react-redux";
import {  createStore , applyMiddleware } from "redux";
import thunk from "redux-thunk";
import  rootReducer  from "./reducers/index";
// import App from './App';
config.set({
    //Change your local domain name here..
    apiUrl: process.env.REACT_APP_apiUrl,
    studioUrl: process.env.REACT_APP_studioUrl,
    partnerUrl: process.env.REACT_APP_partnerUrl,
    mainUrl: process.env.REACT_APP_mainUrl,
    mainUrl_username: process.env.REACT_APP_mainUrl_username,
    mainUrl_password: process.env.REACT_APP_mainUrl_password,
    enc_key: process.env.REACT_APP_enc_key,
    enc_iv: process.env.REACT_APP_enc_iv
});

const store = createStore(rootReducer , applyMiddleware(thunk));
ReactDOM.render(
    <Provider store={store}>
        <Routing />
    </Provider>

, document.getElementById('root'));
serviceWorker.unregister();


// WEBPACK FOOTER //
// ./src/index.js